import { ItemList, ItemType } from '../../../UI/Cube/types'
import kandiBackground from '../../../../assets/image/cube/kandi-test/background.webp'
import { s3PublicStoragePrefix, frontendDomain } from '../../../../utility'
import wahlkreisData from './wahlkreisData'
// import spdMitglied from '../../../../assets/image/cube/tiles/Underconstruction-04.webp'
import whatsapp from '../../../../assets/image/cube/tiles/Underconstruction-05.webp'
import politik from '../../../../assets/image/cube/tiles/Underconstruction-03.webp'
// import spdSeite from '../../../../assets/image/cube/tiles/Underconstruction-06.webp'
// import countdown from '../../../../assets/image/cube/tiles/Underconstruction-02.webp'
// import alarmMail from '../../../../assets/image/cube/tiles/Underconstruction-01.webp'
import tinder from '../../../../assets/image/cube/tiles/04-Tinder.webp'
import olaf from '../../../../assets/image/cube/tiles/01-Olaf.webp'
import briefwahl from '../../../../assets/image/cube/tiles/06-Briefwahl.webp'

const getKandiItems = async (id: string): Promise<ItemList | false> => {
  const blacklist = ['40', '55', '71', '77', '95', '149', '168', '169', '185', '200', '201', '226']
  const wahlkreis = wahlkreisData['wk' + id]

  if (!wahlkreis || blacklist.includes(id)) return false
  const imageURL = `${s3PublicStoragePrefix}custom-static-assets/kandi-images/${id}.webp`

  const items: ItemList = [
    {
      type: ItemType.KANDI,
      kandi: {
        outline: imageURL,
        firstname: wahlkreis.firstname,
        lastname: wahlkreis.lastname,
      },
      src: kandiBackground,
      link: `https://kandidierende.spd.de/wk/${id}`,
    },
    {
      type: ItemType.IMAGE,
      src: whatsapp,
      link: 'https://www.spd.de/whatsapp/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
      openExternal: true,
    },
    {
      type: ItemType.IMAGE,
      src: olaf,
      link: '/olaf',
    },
    // {
    //   type: ItemType.COUNTDOWN,
    //   targetDate: countdownTargetDate,

    //   src: countdown,
    // },
    {
      type: ItemType.IMAGE,
      src: politik,
      link: `${frontendDomain}/programm?kandidat=${id}`,
    },
    // {
    //   type: ItemType.IMAGE,
    //   src: spdSeite,
    //   link: 'https://spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
    //   openExternal: true,
    // },
    {
      type: ItemType.IMAGE,
      src: briefwahl,
      link: 'https://briefwahl.spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
      openExternal: true,
    },
    // {
    //   type: ItemType.IMAGE,
    //   src: spdMitglied,
    //   link: 'https://mitgliedwerden.spd.de/?utm_source=qr&utm_medium=cube&utm_campaign=btw25',
    //   openExternal: true,
    // },
    {
      type: ItemType.IMAGE,
      src: tinder,
      link: `https://kandidierende.spd.de/dein-programm/`,
      openExternal: true,
    },
    // {
    //   type: ItemType.IMAGE,
    //   src: alarmMail,
    //   link: `${frontendDomain}/newsalarm?kandidat=${id}`,
    // },
  ]

  return items
}

export default getKandiItems
